import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { UserDetails } from 'src/app/models/user-details.model';
@Injectable({
  providedIn: 'root'
})
export class UserDetailsService implements Resolve<any> {

  constructor(private sessionService: BrowserStorageService,
    private authService: AuthService) { }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<UserDetails>|Promise<UserDetails>| UserDetails {
      return this.getUserDetails()
    }

  /**
   * Get Licence Data
   * @returns
   */
  getUserDetails(): Observable<UserDetails> {
      if (!this.sessionService.getSessionData()) {
          let userData: any = {}
          return of(userData);
      } else {
        return this.authService.getCurrentUserDetails().pipe(
          map((response: UserDetails) => {
            return response;
          }),
          catchError((error) => {
            return throwError(error);
          })
        )
      }
  }
}
